import { contactData } from '@/mocks/homeData';

export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-extrabold text-foreground-950 font-heading">{contactData.title}</h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base">{contactData.subtitle}</p>
        </div>
        <div className="max-w-2xl mx-auto bg-background-50 rounded-xl p-6 md:p-10 border border-background-200/70">
          <p className="text-foreground-700 text-sm md:text-base leading-relaxed mb-8">{contactData.description}</p>
          <div className="flex flex-col gap-4">
            {contactData.items.map((item, i) => (
              <div key={i} className="flex items-center gap-4 p-4 rounded-lg bg-background-100 border border-background-200/60">
                <div className="w-11 h-11 flex items-center justify-center bg-primary-100 rounded-lg flex-shrink-0">
                  <i className={`${item.icon} text-primary-500 text-xl`}></i>
                </div>
                <div>
                  <div className="text-xs text-foreground-500 font-medium">{item.label}</div>
                  <div className="text-sm md:text-base font-semibold text-foreground-900">{item.value}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}